import { render, staticRenderFns } from "./OrderShip.vue?vue&type=template&id=767ad69b&"
import script from "./OrderShip.vue?vue&type=script&lang=js&"
export * from "./OrderShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports